import { LayerType } from "../../types";
import { ConstraintsLayerType } from "../ConstraintsLayerType";
import { TrafficSelectionSidebar } from "./TrafficSelectionSidebar";
import { trafficClickResolver } from "./trafficClickResolver";
import { TrafficLayerSummary } from "./TrafficLayerSummary";

export const RoadAndTrafficLayerType: LayerType = {
  ...ConstraintsLayerType,
  LayerSummary: TrafficLayerSummary,
  Printable: undefined,
  clickResolver: trafficClickResolver,
  SelectionSidebar: undefined,
};

export const TrafficLayerType: LayerType = {
  LayerSummary: TrafficLayerSummary,
  Printable: undefined,
  SelectionSidebar: TrafficSelectionSidebar,
  Provider: ConstraintsLayerType.Provider,
};
